import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { apiServiceShape } from 'helpers/shapes';
import MakeHash from 'make-hash';
import moment from 'moment';
import Endpoints from 'helpers/enums/endpoints';
import BodyDataNormalizer from 'normalizers/body-data-normalizer';
import Hero from 'components/heroes/hero';
import DataModule from 'pages/body-data/_data-module';
import ProgressArea from 'pages/body-data/_progress-area';
import Page from 'components/page/page';
import LoaderHelper from 'helpers/utilities/loader-helper';
import messages from './messages';

class BodyData extends React.Component {
    constructor(props) {
        super(props);

        const { intl } = props;

        this.state = {
            data: [],
            serverError: false,
            loading: true,
        };

        this.page = {
            heading: intl.formatMessage(messages.heading),
            intro: intl.formatMessage(messages.intro),
            error: intl.formatMessage(messages.load_error),
        };

        /**
         * Flag to track the mounted state of the component so setState is not
         * called on a component that has been destroyed
         *
         * @type {Boolean}
         */
        this._isMounted = false;

        this.setUpHandlers();
    }

    /**
     * Binds any handlers to the correct context
     *
     * @method  setUpHandlers
     */
    setUpHandlers() {
        this.onError = this.handleError.bind(this);
    }

    /**
     * React Lifecycle Hook
     * Invoked once, immediately before mounting occurs. It is called before
     * render(), therefore setting state synchronously in this method will not
     * trigger a re-rendering.
     *
     * @method  componentWillMount
     */
    componentWillMount() {
        this.getData();
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getData() {
        const startTime = moment();
        this.setState({
            serverError: false,
        });

        this.props.apiService
            .get(Endpoints.bodyData, this.onError)
            .then((data) => {
                const normalizedData = BodyDataNormalizer.normalize(data);

                this.setState({
                    data: normalizedData,
                });
            })
            .then(() => {
                LoaderHelper(startTime, () => {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                        });
                    }
                });
            });
    }

    handleError(error) {
        this.setState({
            serverError: true,
            loading: false,
        });
    }

    _renderDataModules() {
        return !this.state.data.length
            ? ''
            : this.state.data.map((data, i) => {
                  return (
                      <DataModule
                          key={MakeHash(`${data.type}-${i}`)}
                          data={data}
                      />
                  );
              });
    }

    _renderHero() {
        const heroText = this.state.serverError
            ? this.page.error
            : this.page.intro;
        const progressArea = this.state.data.length ? (
            <ProgressArea data={this.state.data} />
        ) : (
            ''
        );

        return (
            <Hero
                title={this.page.heading}
                supportingTxt={heroText}
                serverError={this.state.serverError}
                aside={progressArea}
                scrollTo=".js-page-main"
            />
        );
    }

    render() {
        const pageHero = this._renderHero();
        const dataModules = this._renderDataModules();

        return (
            <Page
                fullTexture={this.state.loading || this.state.serverError}
                isLoading={this.state.loading}
                title={this.page.heading}
                pageHero={pageHero}
                mainClasses="page-main_disengagedTop"
            >
                {dataModules}
            </Page>
        );
    }
}

BodyData.propTypes = {
    apiService: apiServiceShape.isRequired,
};

export default injectIntl(BodyData);



// WEBPACK FOOTER //
// ./src/client/pages/body-data/body-data.jsx